/** Beklenmeyen render hatalarını yakalar; boş beyaz ekran bırakmaz. */

import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { Button } from "../ui/primitives";
import { M } from "../dil";

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly error: Error | null;
  readonly stack: string | undefined;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null, stack: undefined };

  static getDerivedStateFromError(error: Error): State {
    return { error, stack: undefined };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Geliştirme sırasında görünür olması gerekiyor; uzak günlükleme yok.
    console.error("Parafon arayüz hatası:", error, info.componentStack);
    this.setState({ error, stack: info.componentStack ?? undefined });
  }

  private readonly reset = (): void => {
    this.setState({ error: null });
  };

  override render(): ReactNode {
    const { error, stack } = this.state;
    if (error === null) return this.props.children;
    return (
      <div className="mx-auto max-w-2xl p-6">
        <div role="alert" className="pf-card p-4">
          <h1 className="text-[16px] font-semibold text-danger">{M.kabuk.hataSinir.baslik}</h1>
          <p className="mt-2 text-[13px] text-ink">
            {M.kabuk.hataSinir.dokunulmadi}
          </p>
          <p className="mt-2 text-[13px] text-muted">{error.message}</p>
          {stack !== undefined && (
            <details className="mt-3">
              <summary className="cursor-pointer text-[12px] text-muted">{M.kabuk.hataSinir.teknikAyrinti}</summary>
              <pre className="mt-1 max-h-64 overflow-auto whitespace-pre-wrap text-[11px] text-muted">{stack}</pre>
            </details>
          )}
          <div className="mt-4 flex gap-2">
            <Button variant="primary" onClick={this.reset}>
              {M.kabuk.hataSinir.yenidenCiz}
            </Button>
            <Button onClick={() => globalThis.location?.reload()}>{M.kabuk.hataSinir.sayfayiYenile}</Button>
          </div>
        </div>
      </div>
    );
  }
}
